import { useEffect } from "react";
import { usePackage } from "../../../hooks/package";
import { useApplicationId } from "../../../hooks/useApplicationId";
import { useSelectPackageMutation } from "../../../services/package";
import { usePreSelectedPackage } from "./usePreSelectedPackage";

const useSelectPackage = () => {
	const preSelectedPackage = usePreSelectedPackage();
	const { selectedPackage } = usePackage();
	const applicationId = useApplicationId();
	const [selectPackageMutation] = useSelectPackageMutation();

	useEffect(() => {
		if (selectedPackage || !preSelectedPackage) return;

		void selectPackageMutation({
			applicationId,
			packageId: preSelectedPackage.packageId,
		});
	}, [applicationId, preSelectedPackage, selectedPackage, selectPackageMutation]);
};

export default useSelectPackage;
